import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=4a21593f"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionHeader: require('/opt/build/repo/components/section/Header.vue').default,ShopSliderDesktop: require('/opt/build/repo/components/shop/SliderDesktop.vue').default,ShopSliderMobile: require('/opt/build/repo/components/shop/SliderMobile.vue').default})
